// DO NOT EDIT THIS FILE
// This file was generated by a Vite plugin
// Do not manually edit this file; it is always overwritten

const englishStrings = {};

export { englishStrings };
